function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { useContext } from 'react';
import { FlagshipContext } from './FlagshipContext';
import { logError, logWarn } from './utils';
import { Flag } from './Flag';
import { noVisitorDefault, noVisitorMessage } from './constants';

var checkType = function checkType(value, defaultValue) {
  return _typeof(value) === 'object' && _typeof(defaultValue) === 'object' && Array.isArray(value) === Array.isArray(defaultValue) || _typeof(value) === _typeof(defaultValue);
};

var fsModificationsSync = function fsModificationsSync(args) {
  var visitor = args.visitor,
      params = args.params,
      activateAll = args.activateAll,
      state = args.state,
      functionName = args.functionName,
      config = args.config;

  if (visitor) {
    return visitor.getModificationsSync(params, activateAll);
  }

  var check = !state.status.isSdkReady && !!state.modifications && state.modifications.size > 0;
  var flags = {};

  if (check) {
    params.forEach(function (item) {
      var _state$modifications;

      var modification = (_state$modifications = state.modifications) === null || _state$modifications === void 0 ? void 0 : _state$modifications.get(item.key);

      if (modification && checkType(modification === null || modification === void 0 ? void 0 : modification.value, item.defaultValue)) {
        flags[item.key] = modification.value;
      } else {
        flags[item.key] = item.defaultValue;
      }
    });
    return flags;
  }

  logWarn(config, noVisitorDefault, functionName);
  params.forEach(function (item) {
    flags[item.key] = item.defaultValue;
  });
  return flags;
};
/**
 * Retrieve a modification value by its key. If no modification match the given key or if the stored value type and default value type do not match, default value will be returned.
 * @deprecated use useFsGetFlag instead
 */


export var useFsModifications = function useFsModifications(params, activateAll) {
  var _useContext = useContext(FlagshipContext),
      state = _useContext.state;

  var visitor = state.visitor,
      config = state.config;
  var functionName = 'useFsModifications';
  return fsModificationsSync({
    functionName: functionName,
    state: state,
    visitor: visitor,
    config: config,
    params: params,
    activateAll: activateAll
  });
};
/**
 * Retrieve a modification value by its key. If no modification match the given key or if the stored value type and default value type do not match, default value will be returned.
 * @deprecated use useFsGetFlag instead
 */

export var useFsModification = function useFsModification(params) {
  var _state$modifications2;

  var _useContext2 = useContext(FlagshipContext),
      state = _useContext2.state;

  var visitor = state.visitor,
      config = state.config;
  var functionName = 'useFsModifications';

  if (visitor) {
    return visitor.getModificationSync(params);
  }

  var modification = (_state$modifications2 = state.modifications) === null || _state$modifications2 === void 0 ? void 0 : _state$modifications2.get(params.key);

  if (!state.status.isSdkReady && modification && checkType(modification === null || modification === void 0 ? void 0 : modification.value, params.defaultValue)) {
    return modification.value;
  }

  logWarn(config, noVisitorDefault, functionName);
  return params.defaultValue;
};

var fsModificationInfoSync = function fsModificationInfoSync(args) {
  var _state$modifications3;

  var key = args.key,
      visitor = args.visitor,
      state = args.state;

  if (visitor) {
    return visitor.getModificationInfoSync(key);
  }

  var modification = (_state$modifications3 = state.modifications) === null || _state$modifications3 === void 0 ? void 0 : _state$modifications3.get(key);

  if (!state.status.isSdkReady && modification) {
    return modification;
  }

  return null;
};
/**
 * Get the campaign modification information value matching the given key.
 * @param {string} key key which identify the modification.
 * @deprecated use useFsGetFlag instead
 */


export var useFsModificationInfo = function useFsModificationInfo(key) {
  var _useContext3 = useContext(FlagshipContext),
      state = _useContext3.state;

  var visitor = state.visitor;
  return fsModificationInfoSync({
    key: key,
    state: state,
    visitor: visitor
  });
};

var fsActivate = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params, functionName, visitor, config) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            if (visitor) {
              _context.next = 4;
              break;
            }

            logWarn(config, noVisitorMessage, functionName);
            return _context.abrupt("return");

          case 4:
            _context.next = 6;
            return visitor.activateModifications(params);

          case 6:
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            logWarn(config, _context.t0.message || _context.t0, functionName);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));

  return function fsActivate(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * This hook returns a flag object by its key. If no flag match the given key an empty flag will be returned.
 * @param key
 * @param defaultValue
 * @returns
 */


export var useFsFlag = function useFsFlag(key, defaultValue) {
  var _useContext4 = useContext(FlagshipContext),
      state = _useContext4.state;

  var visitor = state.visitor;

  if (!visitor) {
    return new Flag(defaultValue);
  }

  return visitor.getFlag(key, defaultValue);
};
/**
 * Report this user has seen this modification. Report this user has seen these modifications.
 * @param params
 * @deprecated use useFsGetFlag instead
 * @returns
 */

export var useFsActivate = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(params) {
    var _useContext5, state, visitor, config, functionName;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _useContext5 = useContext(FlagshipContext), state = _useContext5.state;
            visitor = state.visitor, config = state.config;
            functionName = 'useFsModifications';
            _context2.next = 5;
            return fsActivate(params, functionName, visitor, config);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function useFsActivate(_x5) {
    return _ref2.apply(this, arguments);
  };
}();
export var useFlagship = function useFlagship() {
  var _useContext6 = useContext(FlagshipContext),
      state = _useContext6.state;

  var visitor = state.visitor,
      config = state.config;

  var fsUpdateContext = function fsUpdateContext(context) {
    var functionName = 'updateContext';

    if (!visitor) {
      logError(config, noVisitorMessage, functionName);
      return;
    }

    visitor.clearContext();
    visitor.updateContext(context);
  };

  var fsClearContext = function fsClearContext() {
    var functionName = 'cleanContext';

    if (!visitor) {
      logError(config, noVisitorMessage, functionName);
      return;
    }

    visitor.clearContext();
  };

  var fsAuthenticate = function fsAuthenticate(visitorId) {
    var functionName = 'authenticate';

    if (!visitor) {
      logError(config, noVisitorMessage, functionName);
      return;
    }

    visitor.authenticate(visitorId);
  };

  var fsUnauthenticate = function fsUnauthenticate() {
    var functionName = 'unauthenticate';

    if (!visitor) {
      logError(config, noVisitorMessage, functionName);
      return;
    }

    visitor.unauthenticate();
  };
  /**
   * Send a Hit to Flagship servers for reporting.
   */


  var fsSendHit = function fsSendHit(hit) {
    var functionName = 'sendHit';

    if (!visitor) {
      logError(config, noVisitorMessage, functionName);
      return Promise.resolve();
    }

    return visitor.sendHit(hit);
  };
  /**
   * Send a Hit to Flagship servers for reporting.
   */


  var fsSendHits = function fsSendHits(hit) {
    var functionName = 'sendHits';

    if (!visitor) {
      logError(config, noVisitorMessage, functionName);
      return Promise.resolve();
    }

    return visitor.sendHits(hit);
  };

  var modifications = visitor === null || visitor === void 0 ? void 0 : visitor.getModificationsArray();

  if (!state.status.isSdkReady && state.modifications) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    modifications = Array.from(state.modifications, function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          _key = _ref4[0],
          item = _ref4[1];

      return item;
    });
  }

  var activateModification = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(params) {
      var functionName;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              functionName = 'activateModification';
              _context3.next = 3;
              return fsActivate(params, functionName, visitor, config);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function activateModification(_x6) {
      return _ref5.apply(this, arguments);
    };
  }();

  var synchronizeModifications = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (visitor) {
                _context4.next = 3;
                break;
              }

              logWarn(config, noVisitorMessage, 'synchronizeModifications');
              return _context4.abrupt("return");

            case 3:
              _context4.next = 5;
              return visitor.synchronizeModifications();

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function synchronizeModifications() {
      return _ref6.apply(this, arguments);
    };
  }();

  var getModifications = function getModifications(params, activateAll) {
    var functionName = 'getModifications';
    return fsModificationsSync({
      functionName: functionName,
      state: state,
      visitor: visitor,
      config: config,
      params: params,
      activateAll: activateAll
    });
  };

  var getModificationInfo = function getModificationInfo(key) {
    return fsModificationInfoSync({
      key: key,
      state: state,
      visitor: visitor
    });
  };

  function getFlag(key, defaultValue) {
    if (!visitor) {
      return new Flag(defaultValue);
    }

    return visitor.getFlag(key, defaultValue);
  }

  function fetchFlags() {
    if (!visitor) {
      logWarn(config, noVisitorMessage, 'fetchFlags');
      return Promise.resolve();
    }

    return visitor.fetchFlags();
  }

  function setConsent(hasConsented) {
    if (!visitor) {
      logWarn(config, noVisitorMessage, 'setConsent');
      return;
    }

    visitor.setConsent(hasConsented);
  }

  return {
    visitorId: visitor === null || visitor === void 0 ? void 0 : visitor.visitorId,
    anonymousId: visitor === null || visitor === void 0 ? void 0 : visitor.anonymousId,
    context: _objectSpread({}, visitor === null || visitor === void 0 ? void 0 : visitor.context),
    hasConsented: visitor === null || visitor === void 0 ? void 0 : visitor.hasConsented,
    setConsent: setConsent,
    updateContext: fsUpdateContext,
    clearContext: fsClearContext,
    authenticate: fsAuthenticate,
    unauthenticate: fsUnauthenticate,
    status: state.status,
    activateModification: activateModification,
    synchronizeModifications: synchronizeModifications,
    getModifications: getModifications,
    modifications: modifications || [],
    FlagsData: (visitor === null || visitor === void 0 ? void 0 : visitor.getFlagsDataArray()) || [],
    getModificationInfo: getModificationInfo,
    hit: {
      send: fsSendHit,
      sendMultiple: fsSendHits
    },
    getFlag: getFlag,
    fetchFlags: fetchFlags
  };
};